import { render, staticRenderFns } from "./BaseVisaIcon.vue?vue&type=template&id=1821812c&scoped=true"
import script from "./BaseVisaIcon.vue?vue&type=script&lang=js"
export * from "./BaseVisaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1821812c",
  null
  
)

export default component.exports